/**
 * Podium colours, shared by everything that shows a placing: medals, trophies and the top three of a
 * ranking.
 *
 * The colour itself is defined once, in main.css (`.podium-1/2/3`): this module only knows which
 * class goes with which placing.
 *
 * A class colours an icon or a text, but a coloured surface — a tonal chip or avatar — needs a
 * colour prop and cannot take a class: PODIUM_COLORS names the Vuetify colours of the same family,
 * so the two can be used side by side without the palette drifting apart.
 */

/** Vuetify colours of the podium places, for the surfaces that need a colour prop. */
const PODIUM_COLORS = ['amber-darken-1', 'blue-grey-lighten-2', 'brown-lighten-1']

/** Number of places on the podium: 1 gold, 2 silver, 3 bronze. */
export const PODIUM_SIZE = PODIUM_COLORS.length

/** CSS class that colours a placing (see `.podium-*` in main.css); null outside the podium. */
export function podiumClass(place)
{
  return place >= 1 && place <= PODIUM_SIZE ? `podium-${place}` : null
}

/** Vuetify colour of a placing, for the surfaces that need a colour prop; null outside the podium. */
export function podiumColor(place)
{
  return PODIUM_COLORS[place - 1] ?? null
}
